import { GIANT_IDS, type GiantId } from '../ids/ids';

/**
 * Допустимые препятствия по гиганту (GDD, раздел «Препятствия»).
 * Стабильные id для уровней и data-oriented спавна.
 * Ключи — GiantId v3.
 */
export const GIANT_ALLOWED_OBSTACLES = {
  svami: ['swarm_copters', 'decree_scrolls', 'king_crowns'],
  roza: [
    'comets',
    'mountain_mist',
    'shooting_stars',
    'weave_stars',
    'hard_caramels',
  ],
  drakochi: ['lava_towers', 'chili_peppers', 'soundwaves', 'heat_zone'],
  yetti: [
    'hanging_icicles',
    'snowflake_drifts',
    'snowball_hail',
    'ice_sculptures',
    'ice_cream_traps',
    'frozen_notes',
    'blizzard_cold',
  ],
  mona: [
    'kraken_snare',
    'dolphin_playmates',
    'foam_waves',
    'shrinking_growing_bottles',
  ],
  duck: ['passenger_dolphins', 'wake_breakers', 'pool_orbs', 'sea_whirlpool'],
  serj: ['serge_minions', 'ink_poems'],
  factor: ['sand_wall', 'prairie_weeds', 'chimney_smoke', 'loose_cogs'],
  willy: ['spectacle_glare', 'faded_decrees', 'memory_photos'],
  sol: ['heat_haze_clouds', 'sky_choppers'],
  mu: ['phantom_lights', 'dark_islands', 'meteor_shower', 'night_comets'],
} as const satisfies { [K in GiantId]: readonly string[] };

export type ObstacleKind = (typeof GIANT_ALLOWED_OBSTACLES)[GiantId][number];

export const ALL_OBSTACLE_KINDS: ObstacleKind[] = Array.from(
  new Set(GIANT_IDS.flatMap((g) => [...GIANT_ALLOWED_OBSTACLES[g]])),
) as ObstacleKind[];

export function getAllowedObstaclesForGiant(giantId: GiantId): readonly ObstacleKind[] {
  return GIANT_ALLOWED_OBSTACLES[giantId];
}

export function isObstacleKind(value: string): value is ObstacleKind {
  return (ALL_OBSTACLE_KINDS as readonly string[]).includes(value);
}

export function isObstacleAllowedForGiant(giantId: GiantId, obstacle: ObstacleKind): boolean {
  return (GIANT_ALLOWED_OBSTACLES[giantId] as readonly string[]).includes(obstacle);
}
